import { css } from "@emotion/css";
import React from "react";
import { Modal as AriaModal } from "react-aria-components";

import { _Modal } from "./assets/_Modal";
import { _ModalOverlay } from "./assets/_ModalOverlay";

interface Props extends React.ComponentProps<typeof AriaModal> {
  scroll?: "viewport" | "body";
  testID?: string;
}

/** @deprecated Please update import to `@certn/cascadia` to add cross-platform support. See CHEESE-213 for more details. */
export function Modal(props: Props) {
  const {
    scroll,
    testID = "modal",
    isOpen,
    onOpenChange,
    ...modalProps
  } = props;

  return (
    <_ModalOverlay
      className={styles.overlay}
      isDismissable={props.isDismissable}
      isKeyboardDismissDisabled={props.isKeyboardDismissDisabled}
      isEntering={props.isEntering}
      isExiting={props.isExiting}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      scroll={scroll}
      data-testid={`${testID}-overlay`}
    >
      <_Modal {...modalProps} data-testid={testID} />
    </_ModalOverlay>
  );
}

const styles = {
  overlay: css({ zIndex: 100 }),
};
